export type RubroRemoveConfirmCopy = {
  title: string
  body: string
  confirmLabel: string
  cancelLabel: string
}

export function getRubroRemoveConfirmCopy(appliesOnSave: boolean): RubroRemoveConfirmCopy {
  if (appliesOnSave) {
    return {
      title: '¿Quitar este rubro del proyecto?',
      body:
        'El rubro dejará de formar parte del proyecto cuando guardes los cambios con "Guardar cambios". Hasta entonces podés seguir editando el resto de la obra. La información de este rubro no se incluirá al guardar.',
      confirmLabel: 'Quitar rubro',
      cancelLabel: 'Cancelar'
    }
  }
  return {
    title: '¿Eliminar este rubro?',
    body:
      'Este rubro se quita del borrador. La documentación, fechas y planillas que tenías en él no se pueden recuperar.',
    confirmLabel: 'Eliminar rubro',
    cancelLabel: 'Cancelar'
  }
}
